export const PolicyRoles = [
  { label: '', value: '' },
  { label: 'Owner', value: 'owner' },
  { label: 'Life Assured', value: 'lifeAssuredOne' },
  { label: 'Joint Life Assured', value: 'lifeAssuredTwo' },
  { label: 'Third Party Payor', value: 'thirdPartyPayor' },
  { label: 'PEP', value: 'pep' },
  { label: 'Beneficial Owner', value: 'bo' },
  { label: 'Joint Policy Owner', value: 'jointPolicyOwner' },
  { label: 'Joint Owner', value: 'jointOwner' },
  { label: 'Assignee', value: 'assignee' },
  { label: 'Assignor', value: 'assignor' },
  { label: 'Officer / Authorised Representative', value: 'officerAuthorisedRepresentative' },
  { label: 'Shareholder', value: 'shareholder' },
  { label: 'Authorised Signatory', value: 'authorisedSignatory' }
]
